<template>
	<div class="message_box animate__animated animate__fadeIn">
		<div class="message">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">读取状态</div>
						<el-select size="small" v-model="searchReadStatus" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0; vertical-align: bottom">
							<el-option value="">请选择</el-option>
							<el-option label="未读" value="0">未读</el-option>
							<el-option label="已读" value="1">已读</el-option>
						</el-select>
					</div>
					<div class="line_input">
						<div class="input_title">通知日期</div>
						<el-date-picker
							size="small"
							v-model="searchNoticeDate"
							type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 392px;"
						></el-date-picker>
					</div>
					<div class="search-btn" @click="fnSearch"><span>搜索</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">通知人</div>
					<div class="title_item">通知内容</div>
					<div class="title_item">是否已读</div>
					<div class="title_item">通知日期</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="tableData">
							<div class="box_line" v-for="(item,index) in tableData" :key="index">
								<div class="list_item">{{ item.auth_name }}</div>
								<div class="list_item contentmsg">
									<div class="msg_box" v-html="item.content"></div>
								</div>
								<div class="list_item" :class="item.read_state==0?'red-c':''">{{ item.read_state == 0 ? '未读' : '已读' }}</div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">
									<div>
										<button class="item_btn blue" @click="fnOpenNotice(item)"><span>查看详情</span></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>
			<div class="dialog_msg animate__animated animate__fadeIn" v-if="showNoticeWin">
				<el-dialog :modal="false" title="消息详情" center :visible.sync="showNoticeWin">
					<div class="content_detail">
						<div class="message_boxes">
							<div class="message_detail" v-html="showNotice.content"></div>
						</div>
						<div class="auth_name">{{ showNotice.auth_name }}</div>
						<div class="create_at">{{ showNotice.create_at }}</div>
					</div>
					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search-btn red" @click="showNoticeWin = false"><span>关闭</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
import request from '@/utils/request';
import APP from '@/utils/base';
import { setPageAuth, getUserInfo } from '@/utils/auth';
import store from '../../../store';
export default {
	data() {
		return {
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			userInfo: null, // 项目登录缓存信息
			searchReadStatus: '', // 搜索读取状态
			searchNoticeDate: '', // 搜索通知日期
			searchtime: '', // 搜索时间格式化
			tableData: [], // 表格数据
			showNoticeWin: false, // 消息详情弹窗
			showNotice: {} // 消息详情
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		fnInit() {
			this.userInfo = getUserInfo();
			this.fnGetNoticeData({
				page: this.currentPage,
				size: this.pageSize,
				region: this.userInfo.region.replace(/[^0-9]/gi, '')
			},
			res => {
				this.tableData = res.data.query;
				this.pageTotal = res.data.count;
			});
		},
		// 分页
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearch();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnSearch();
		},
		// 获取数据
		fnGetNoticeData(_obj, _cb) {
			request({
				url: 'projectIndex/getMessages',
				method: 'GET',
				params: _obj
			})
			.then(res => {
				_cb && _cb(res);
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 搜索
		fnSearch() {
			if (this.searchNoticeDate) {
				this.searchtime = this.searchNoticeDate[0] + ',' + this.searchNoticeDate[1];
			} else {
				this.searchtime = '';
			}
			this.fnGetNoticeData({
				page: this.currentPage,
				size: this.pageSize,
				region: this.userInfo.region.replace(/[^0-9]/gi, ''),
				read_state: this.searchReadStatus,
				create_at: this.searchtime
			},
			res => {
				this.tableData = res.data.query;
				this.pageTotal = res.data.count;
			});
		},
		// 查看详情
		fnOpenNotice(_data) {
			if (_data.read_state == 1) {
				this.showNotice = _data;
				this.showNoticeWin = true;
				return false;
			}
			request({
				url: 'projectIndex/readMessages',
				method: 'GET',
				params: {
					notice_id: _data.id
				}
			})
			.then(res => {
				this.showNotice = _data;
				this.showNoticeWin = true;
				store.dispatch('ChageMsg', store.state.message.msgCount - 1);
				this.fnInit();
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		}
	}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.message_box{
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.message{
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box{
	height: 32px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between,center,column);
	.box_line{
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start,center);
		.line_input{
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start,center);
			.input_title{
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9BF9FC;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center,center);
			}
			.select_box{
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
	}
}
.cont_list{
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 691px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title{
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start,center);
		.title_item{
			height: 48px;
			@include flex-box(center,center);
			&:nth-child(1){
				width: 156px;
                margin: 0 4px 0 40px;
			}
			&:nth-child(2){
				width: 926px;
                margin-right: 4px;
			}
			&:nth-child(3){
				width: 186px;
				margin-right: 4px;
			}
			&:nth-child(4){
				width: 256px;
				margin-right: 4px;
			}
			&:nth-child(5){
				width: 260px;
				margin-right: 40px;
			}
		}
	}
	.list_boxes{
		width: 1864px;
		height: 643px;
		position: relative;
		overflow: hidden;
		.list_box{
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line{
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #FFFFFF;
				border-bottom: 1px dashed #1D4495;
				@include flex-box(flex-start,center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item{
					height: 70px;
					text-align: center;
					@include flex-box(center,center);
					&:nth-child(1){
                        width: 156px;
						margin-right: 4px;
					}
					&:nth-child(2){
						width: 926px;
						margin-right: 4px;
					}
					&:nth-child(3){
						width: 186px;
						margin-right: 4px;
					}
					&:nth-child(4){
						width: 256px;
						margin-right: 4px;
					}
					&:nth-child(5){
						width: 260px;
					}
					&.contentmsg{
						width:926px;
						max-height: 70px;
						cursor: pointer;
						position: relative;
						overflow: hidden;
						.msg_box{
							position: absolute;
							left: 0;
							right: -25px;
							top: 0;
							bottom: 0;
							overflow-x: hidden;
							overflow-y: auto;
						}
					}
					&.red-c{
						color: #df7475;
					}
					div{
						@include flex-box(center,center);
						.item_btn{
							width: 89px;
							height: 32px;
							line-height: 32px;
							margin: 0 2px;
							font-size: 14px;
							color: #FFFFFF;
							border: none;
							cursor: pointer;
							@include flex-box(center,center);
							&.blue{
								background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
								background-size: 100% 100%;
							}
							span{
								margin-top: -2px;
							}
						}
					}
				}
			}
		}
	}
}
.box_line{
>>>.el-input__inner{
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder{
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder{   /* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select {
		.el-input {
			.el-select__caret{
				color: rgba(77, 180, 244, 0.7);
			}
		}
	}
	>>>.el-select-dropdown{
		background-color: rgba(77, 180, 244, 0.2);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>>.popper__arrow{
		border-bottom-color: rgba(77, 180, 244, 1)!important;
	}
	>>>.el-select-dropdown__item{
		color: rgba(77, 180, 244, 0.7);
	}
	>>>.el-select-dropdown__item:hover{
			color:#409eff;
	}
	>>>.el-select-dropdown__item.hover{
			color:#409eff;
	}
	>>>.el-input__icon{
		color: rgba(77, 180, 244, 0.7);
	}
	>>>.el-range-input{
		background: transparent;
		&::-webkit-input-placeholder{
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder{   /* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-range-separator{
		color: rgba(77, 180, 244, 0.7);
	}
}

.dialog_msg{
	.btn_line{
		@include flex-box(center,center);
	}
	>>>.el-dialog{
		width: 800px;
		height: 500px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58,116,221,1);
	}
	>>>.el-form-item__label{
		color: #4DB4F4;
	}
	>>>.el-dialog__title{
		color: #4DB4F4;
	}
	>>>.el-dialog__close{
		color: #4DB4F4;
	}
	.content_detail {
		width: 100%;
		height: 325px;
		color: #FFFFFF;
		border: 1px solid rgba(58,116,221,0.5);
		border-radius: 5px;
		.message_boxes{
			width: 98%;
			height: 255px;
			margin: 5px auto;
			overflow: hidden;
			position: relative;
			cursor: pointer;
			border-bottom: 1px solid rgba(58,116,221,0.2);
			.message_detail {
				position: absolute;
				left: 0;
				right: -25px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
			}
		}
		.auth_name,
		.create_at {
			width: 96%;
			height: 30px;
			line-height: 30px;
			text-align: right;
			margin: 0 auto;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Message/MessageDefault/index.vue